interface Props {
  label: string;
  quantity: number;
  max: number;
  onChange: (quantity: number) => void;
}

export function QuantityStepper({ label, quantity, max, onChange }: Props) {
  const button =
    "flex h-9 w-9 items-center justify-center text-lg disabled:cursor-not-allowed disabled:text-(--color-text-placeholder)";

  return (
    <div className="inline-flex items-center rounded-full border border-(--color-surface-border)" role="group" aria-label={`Quantity for ${label}`}>
      <button
        type="button"
        className={button}
        aria-label="Decrease quantity"
        disabled={quantity <= 0}
        onClick={() => onChange(quantity - 1)}
      >
        −
      </button>
      <span className="w-8 text-center text-sm tabular-nums" aria-live="polite">
        {quantity}
      </span>
      <button
        type="button"
        className={button}
        aria-label="Increase quantity"
        disabled={quantity >= max}
        onClick={() => onChange(quantity + 1)}
      >
        +
      </button>
    </div>
  );
}
